// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3E1Pt","list":"BalanceDue_list__1PFVX","listRow":"BalanceDue_listRow__2VVn0","total":"BalanceDue_total__2_bql"};